import { render, staticRenderFns } from "./KpiSatisfaccionGeneral.vue?vue&type=template&id=90bd6d60&"
import script from "./KpiSatisfaccionGeneral.vue?vue&type=script&lang=js&"
export * from "./KpiSatisfaccionGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports